import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Login from "../Login";
import Home from "../Home";
import React from "react";
import Jutge from "../Jutge";
import Database from "../Database";
import Avaluacio from "../Avaluacio";
import Perfil from "../components/content/Perfil";
import UserName from "../UserName";
import CluedoPage from "../CluedoPage";
import CluedoCharacters from "../CluedoCharacters";
import CastronegroCharacters from "../CastronegroCharacters";
import CastronegroVotos from "../CastronegroVotos";
import CastronegroAdmin from "../CastronegroAdmin";
import ProtectedRoute from "./ProtectedRoute";

import { IdePage } from "../jutge/ide/IdePage";
import { IdeExamFrame } from "../jutge/ide/IdeExamFrame";
import { IdeExamFrameV2 } from "../jutge/ide/IdeExamFrameV2";
import Metadata from "../Metadata";
import ZeldaUnityGame from "../components/ZeldaUnityGame";
import Javashop from "../components/content/Javashop";
import Javadex from "../components/content/Javadex";
import GameActivityModal from "../components/content/GameActivityModal";
import GameActivitiesModal from "../components/content/GameActivitiesModal";
import IdeAuth from "../IdeAuth";
import TheiaGamePanel from "../jutge/components/TheiaGamePanel";
import GameMochila from "../components/content/GameMochila";
import GameJavamons from "../components/content/GameJavamons";
import GameCapture from "../components/content/GameCapture";

const AppRoutes = () => {

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/home/*" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="/username/*" element={<ProtectedRoute><UserName /></ProtectedRoute>} />
                <Route path="/jutge/*" element={<Jutge />} />
                <Route path="/database/*" element={<ProtectedRoute><Database /></ProtectedRoute>} />
                <Route path="/abp/*" element={<ProtectedRoute><Avaluacio /></ProtectedRoute>} />
                <Route path="/cluedo" element={<ProtectedRoute><CluedoPage /></ProtectedRoute>} />
                <Route path="/cluedo/characters" element={<ProtectedRoute><CluedoCharacters /></ProtectedRoute>} />
                <Route path="/metadata/*" element={<ProtectedRoute><Metadata /></ProtectedRoute>} />
                <Route path="/ide/exam" element={<ProtectedRoute><IdeExamFrame /></ProtectedRoute>} />
                <Route path="/ide/exam-v2" element={<ProtectedRoute><IdeExamFrameV2 /></ProtectedRoute>} />
                <Route path="/game" element={<ProtectedRoute><ZeldaUnityGame /></ProtectedRoute>} />
                <Route path="/game/javashop" element={<ProtectedRoute><Javashop /></ProtectedRoute>} />
                <Route path="/game/equipment" element={<ProtectedRoute><Perfil rpgOnly={true} /></ProtectedRoute>} />
                <Route path="/game/javadex" element={<ProtectedRoute><Javadex isGameModal={true} /></ProtectedRoute>} />
                <Route path="/game/mochila" element={<ProtectedRoute><GameMochila /></ProtectedRoute>} />
                <Route path="/game/javamons" element={<ProtectedRoute><GameJavamons /></ProtectedRoute>} />
                <Route path="/game/capture" element={<ProtectedRoute><GameCapture /></ProtectedRoute>} />
                <Route path="/game/activity/:id_activitat" element={<ProtectedRoute><GameActivityModal /></ProtectedRoute>} />
                <Route path="/game/activities" element={<ProtectedRoute><GameActivitiesModal /></ProtectedRoute>} />
                <Route path="/game/theia-panel" element={<ProtectedRoute><TheiaGamePanel /></ProtectedRoute>} />
                <Route path="/ide-auth" element={<IdeAuth />} />
                <Route path="/beiricastro" element={<CastronegroCharacters />} />
                <Route path="/beiricastro/votos" element={<CastronegroVotos />} />
                <Route path="/beiricastro/votos/admin" element={<CastronegroAdmin />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}

export default AppRoutes;